import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { ApiPathsService } from '../services/api-paths.service';
import { ApiPath } from '../../../../definitions/apis/api-path';

export const apiPathResolver: ResolveFn<ApiPath> = (
	route: ActivatedRouteSnapshot
): Observable<ApiPath> => {
	const dataSvc = inject(ApiPathsService);
	const pathId = route.paramMap.get('pathId');

	return pathId
		? dataSvc.find(pathId).pipe(catchError(() => of(null)))
		: of(null);
};
